import React from "react"

import {
  ProjectPDFGeneralDataOption,
  ProjectPDFInstallationReferencesOption,
  ProjectPDFPriceOption,
  ProjectPDFRoomDataOption
} from "shared/types/PDFExport"

import { ProjectPDFOverlayView } from "./ProjectPDFOverlayView"
import { ProjectPDFOverlayModel } from "./hooks/useProjectPDFOverlayModel"
import { useProjectPDFOverlayViewModel } from "./hooks/useProjectPDFOverlayViewModel"

export interface ProjectPDFOverlayFormData {
  position: ProjectPDFGeneralDataOption[]
  room: ProjectPDFRoomDataOption[]
  price: ProjectPDFPriceOption
  installationReference: ProjectPDFInstallationReferencesOption
}

export interface ProjectPDFOverlayProps extends ProjectPDFOverlayModel {
  autoFocus?: boolean
}

export const ProjectPDFOverlay = React.memo((props: ProjectPDFOverlayProps) => (
  <ProjectPDFOverlayView {...useProjectPDFOverlayViewModel(props)} />
))
